
export interface DeleteToneDto
{
    getMsisdn(): string;
    getLanguage(): string;
    getToneId(): string;
    getPackName(): string;
}

export class DeleteToneDtoImpl implements DeleteToneDto
{
    private msisdn: string;
    private language: string;
    private toneId: string;
    private packName: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getPackName(): string 
    {
        return this.packName;
    }
    setPackName(packName: string)
    {
        this.packName = packName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/deletetone/deletetonedto.tsx